<script>
    import {Col, Container, Row} from "@sveltestrap/sveltestrap";
    /**
     * @typedef {Object} Props
     * @property {import('svelte').Snippet} [left]
     * @property {import('svelte').Snippet} [middle]
     * @property {import('svelte').Snippet} [children]
     * @property {import('svelte').Snippet} [right]
     */

    /** @type {Props} */
    let {
        left,
        middle,
        children,
        right
    } = $props();
</script>

<Container class="button-line" style="margin: 0;">
    <Row class="d-flex align-items-center justify-content-between">
        {#if left}
            <Col class="p-0" style="text-align: left;">
                {@render left?.()}
            </Col>
        {/if}

        {#if middle}
            <Col class="p-0" style="text-align: center;">
                {@render middle?.()}
            </Col>
        {/if}

        <Col class="p-0 d-flex justify-content-end" style="text-align: right;">
            {@render children?.()}
            {@render right?.()}
        </Col>
    </Row>
</Container>

<style>
    :global(.button-line) {
        --element-gap: 0.5rem;
        line-height: 100%;
    }

    :global(.button-line .col > *) {
        margin-left: calc(var(--element-gap) * .5);
        margin-right: calc(var(--element-gap) * .5);
    }

    :global(.button-line .col > *:first-child) {
        margin-left: 0;
    }

    :global(.button-line .col > *:last-child) {
        margin-right: 0;
    }
</style>
